import { useCallback } from 'react';
import { useRegisterUserAsCustomerMutation } from '@src/generated/graphql';
import { getRewardful } from '@src/services/rewardful';

export function useRegisterUser(): { registerUser: () => Promise<void> } {
  const [registerUserAsCustomer] = useRegisterUserAsCustomerMutation();

  const rewardfulService = getRewardful();

  return {
    registerUser: useCallback(async () => {
      await registerUserAsCustomer({
        variables: {
          input: {
            rewardfulReferralId: rewardfulService?.referral,
            couponId: rewardfulService?.coupon?.id,
          },
        },
      });
    }, [registerUserAsCustomer, rewardfulService]),
  };
}
